import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * SEO Component — renders per-page <title>, <meta description>, <meta keywords>, canonical, og/twitter tags.
 * Usage: <SEO title="..." description="..." keywords="..." path="/about" />
 */
function SEO({ title, description, keywords, path = '' }) {
    const BASE_URL = 'https://jdshospital.in';
    const canonical = `${BASE_URL}${path}`;
    const image = `${BASE_URL}/favicon.png`;

    return (
        <Helmet>
            {/* Primary */}
            <title>{title}</title>
            <meta name="title" content={title} />
            <meta name="description" content={description} />
            {keywords && <meta name="keywords" content={keywords} />}
            <link rel="canonical" href={canonical} />
            <meta name="robots" content="index, follow" />

            {/* Open Graph */}
            <meta property="og:type" content="website" />
            <meta property="og:url" content={canonical} />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={image} />
            <meta property="og:site_name" content="JDS Hospitals" />
            <meta property="og:locale" content="en_IN" />

            {/* Twitter */}
            <meta property="twitter:card" content="summary_large_image" />
            <meta property="twitter:url" content={canonical} />
            <meta property="twitter:title" content={title} />
            <meta property="twitter:description" content={description} />
            <meta property="twitter:image" content={image} />
        </Helmet>
    );
}

export default SEO;
